import { genPopulateAttr } from '@utils/util';

export const newsPageAttributes = (): string => {
  const attributes = [['posts', 'article', 'image']];
  return attributes.map(it => genPopulateAttr(it)).join('&');
};
